import React, { useState } from 'react';
import { Modal, DatePicker, Form } from '@maxtropy/components';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { apiV2EnvMonitorDashboardRecalculatePost } from '@maxtropy/device-customer-apis-v2';

interface RecalculateFormValues {
  dateRange: [dayjs.Dayjs, dayjs.Dayjs];
}

interface RecalculateModalProps {
  open: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const RecalculateModal: React.FC<RecalculateModalProps> = ({ open, updateFn, onCancel }) => {
  const [form] = Form.useForm<RecalculateFormValues>();
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      apiV2EnvMonitorDashboardRecalculatePost({
        startTime: values.dateRange[0].startOf('day').valueOf(),
        endTime: values.dateRange[1].endOf('day').valueOf(),
      }).then(res => {
        updateFn();
        form.resetFields();
        onCancel();
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="重计算"
      contentClassName="modal-form-content"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form}>
        <div style={{ marginBottom: 14, color: 'var(--mx-text-desc-color)', fontSize: 14 }}>
          <ExclamationCircleOutlined style={{ color: 'var(--mx-warning-color)', marginRight: 4 }} />
          重计算数值会覆盖现有数据
        </div>
        <Form.Item<RecalculateFormValues>
          name="dateRange"
          label="选择时间"
          rules={[{ required: true, message: '请选择时间范围' }]}
        >
          <DatePicker.RangePicker style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RecalculateModal;
